/**
 * Safely extract a user-facing message from an HTTP / unknown error.
 * Avoids crashes when `error.error` is a string, null, or network-shaped.
 */
export function getHttpErrorMessage(
  error: unknown,
  fallback = "Something went wrong",
): string {
  if (error == null) return fallback;

  if (typeof error === "string" && error.trim()) {
    return error;
  }

  if (typeof error !== "object") {
    return fallback;
  }

  const err = error as Record<string, unknown>;

  const body = err["error"];
  if (typeof body === "string" && body.trim()) {
    return body;
  }
  if (body && typeof body === "object") {
    const msg = (body as Record<string, unknown>)["message"];
    if (typeof msg === "string" && msg.trim()) {
      return msg;
    }
  }

  const topMessage = err["message"];
  if (typeof topMessage === "string" && topMessage.trim()) {
    // Angular HttpErrorResponse defaults to "Http failure response for ..."
    if (!topMessage.startsWith("Http failure response")) {
      return topMessage;
    }
  }

  const status = err["status"];
  if (status === 0) {
    return "Unable to reach the server. Check your connection and try again.";
  }

  return fallback;
}
